import { AiFillCaretLeft } from "react-icons/ai"; 
import { BiSave } from "react-icons/bi"; 
import CxIcon from '../../cx/CxIcon';
import CxIconButtonNew from '../../cx/CxIconButtonNew';
import React from 'react';
import { useNav } from '../../hx/useNav';
import { useTranslation } from '../../hx/useTranslation';
import CxCombo from '../../cx/CxCombo';
import CxSnackbar from '../../cx/CxSnackbar';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import * as FxFetch from '../../fx/FxFetch';
import '../../../styles/main.css';
import GxForm from '../../gx/GxForm';
import { getStoreValue, setStoreValue } from "../../gx/GxStore";


const MxSettSlsERec = (props) => {
  const [{ trans }] = useTranslation();
  const [{ navBack }] = useNav();
  const r_snack_save = React.useRef(null);
  
  const rf_erec = React.useRef(null);

  let r_form = React.useRef(null);

  React.useEffect(() => {
    formLoad();
    // eslint-disable-next-line
  }, []);

  const formLoad = async () => {
    let record = {};
    record['txScopeKey'] = "BRANCH"; record['txScopeVal'] = getStoreValue('StoreSession', 'inBranch');    
    Promise.all([FxFetch.doJsonX('sett/app/r', record)]).then((result) => {
      if (result[0]) {
        rf_erec.current.setVal(result[0][0].txERec||'NO');
      }
    });
  }

  const formSaveCustom = async () => {
    let filter = { "inBranch": getStoreValue('StoreSession', 'inBranch'), };
    let record = {};
    record['txScopeKey'] = "BRANCH"; record['txScopeVal'] = getStoreValue('StoreSession', 'inBranch');    

    record['txERec'] = rf_erec.current.getVal();

    setStoreValue('StoreSession', 'txERec', rf_erec.current.getVal());

    Promise.all([FxFetch.doJsonF("sett/app/u", filter, record)]).then((result) => {
      if (result[0]) {
        if (result[0].theValue === 'OK') {
          r_snack_save.current.setOpen(true);
        }
      }
    });
        
    r_snack_save.current.setOpen(true);
  }

  return (
    <div>
      <GxForm
        moduleName={trans('field.erec')}
        xref={r_form}
        addToolbarButtons={
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <CxIconButtonNew icon={<CxIcon backIcon={<BiSave/>} frontIcon={<AiFillCaretLeft/>} />} classType="ibs_iconbutton_toolbar" onClick={() => formSaveCustom()} tooltip={trans('field.save_and_exit')} />
          </div>
        }
      >
        <CxCombo xref={rf_erec} clearDisabled
          label={`${trans('field.erec')}`}
          list={[
            { id: 'NO', type: 'No' },
            { id: 'VF', type: 'Verifactu' },
          ]}
        />
        
      </GxForm>

      <CxSnackbar xref={r_snack_save} severity="success" value={trans('msg.saved')} onClose={() => navBack()} />
    </div>
  );

}

export default MxSettSlsERec;
